<template>
    <div
        id="login"
        aria-hidden="true"
        aria-labelledby="exampleModalLabel"
        class="modal fade"
        role="dialog"
        tabindex="-1"
        ref="loginmodal"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container loginctn">
                    <div class="row loginctn">
                        <div class="col-lg-12 loginctn">
                            <!-- Form content box start -->
                            <div class="form-content-box shadow-none">
                                <!-- Logo -->
                                <!-- details -->
                                <div class="details py-0">
                                    <h3 v-if="!isResettingPassword">Accesso al sistema</h3>
                                    <h3 v-if="isResettingPassword">Reset Password</h3>
                                    <div v-if="!isResettingPassword" class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-20 in-line pr-lg-1">
                                            <div class="google-bg1">
                                                <a class="text-color" :href='$root.redirectAfterLogin ? "/social/pubblica/google" : "/social/redirect/google"'>
                                                    <i class="fab fa-google"></i>
                                                    Accedi con Google
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-20 in-line pl-lg-1">
                                            <div class="facebook-bg1">
                                                <a class="text-color" :href='$root.redirectAfterLogin ? "/social/pubblica/facebook" : "/social/redirect/facebook"'>
                                                    <i class="fab fa-facebook-f"></i>
                                                    Accedi con Facebook
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Name -->
                                    <blockquote v-if="!isResettingPassword">Oppure </blockquote>

                                    <div v-if="recover">
                                        <!-- Form start -->
                                        <form v-on:submit.prevent="doRequestRecoverPassword">
                                            <div class="form-group">
                                                <input v-model="email" class="input-text" name="email" placeholder="Email" type="email">
                                            </div>
                                            <div class="form-group mb-0">
                                                <button class="btn-md button-theme btn-block" type="submit">Recupera Password</button>
                                            </div>
                                        </form>
                                    </div>

                                    <div v-if="!isResettingPassword && !register && !recover && !isRequestingConfirmEmail" class="login-form">
                                        <!-- Form start -->
                                        <form action="index.html" method="GET">
                                            <div class="form-group">
                                                <input v-model="email" class="input-text" name="email" placeholder="Email" type="email">
                                            </div>
                                            <div class="form-group">
                                                <input v-model="password" class="input-text" name="Password" placeholder="Password" type="password">
                                            </div>
                                            <div class="form-group mb-0">
                                                <button class="btn-md button-theme btn-block" type="button" :disabled="$root.loginPending"  @click="login()">
                                                    <i class="fas fa-spinner fa-spin" v-if="$root.loginPending"></i>
                                                    <span v-else>Accedi</span>
                                                </button>
                                            </div>
                                        </form>
                                        <!-- Form end -->
                                        <div class="footer mt-3">

                                            <span v-if="!register">
                                                Se non sei ancora registrato? <a @click="setRegister">Registrati</a>
                                            </span>
                                            <br v-if="!register">
                                            <span v-if="register">
                                                Se sei già registrato <a @click="setLogin">Accedi</a>
                                            </span>
                                            <br v-if="register">

                                            <span v-if="!isRequestingConfirmEmail">
                                                Non hai ricevuto la mail di conferma? <a @click="setRequestConfirmEmail">Richiedila nuovamente </a>
                                            </span>
                                            <br v-if="!isRequestingConfirmEmail">
                                            <span v-if="!recover">Hai dimenticato la password?
                                                <a  @click="recoverPassword">Recupera Password</a>
                                            </span>
                                            <br v-if="!recover" />
                                            <span v-if="recover || isResettingPassword || isRequestingConfirmEmail">
                                                <a @click="setLogin();">Torna al login</a>
                                            </span>

                                        </div>
                                    </div>

                                    <div v-if=" !isResettingPassword && register && !recover" class="register-form">
                                        <form v-on:submit.prevent="registerUser">
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.nome" class="input-text" name="nome" placeholder="Nome" required type="text">
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.cognome" class="input-text" name="cognome" placeholder="Cognome" required type="text">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.telefono" class="input-text" name="telefono" placeholder="Telefono" type="text">
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.email" class="input-text" name="email" placeholder="Email" required type="email">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.password" class="input-text" name="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z]).{8,}" placeholder="Password" required type="password">
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input v-model="registerdUser.password_confirmation" class="input-text" name="confirm_Password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z]).{8,}" placeholder="Conferma Password" required type="password">
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-12">
                                                    <small class="password-helper">La password deve avere una lunghezza minima di 8 caratteri, contenere una Maiuscola e un carattere speciale ( !,",?,*)</small>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <small>Questa form è protetta da reCAPTCHA e si applicano la <a href="https://policies.google.com/privacy">Privacy Policy</a> e le <a href="https://policies.google.com/terms">Condizioni di Servizio</a> di Google</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="pull-left">
                                                        <label>
                                                            <input v-model="registerdUser.privacy" class="ez-checkbox label-check" required type="checkbox">
                                                            Accetto il trattamento dei miei dati personali
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group mb-0">
                                                <invisible-recaptcha class="btn-md button-theme btn-block" type="submit" v-if="captchakey" :sitekey="captchakey" :callback="registerUser">Registrati</invisible-recaptcha>
                                            </div>
                                        </form>
                                    </div>

                                    <div v-if="isResettingPassword" class="reset-password-form">
                                        <form v-on:submit.prevent="doResetPasswordRequest">
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input
                                                        v-model="passwordResetData.password"
                                                        class="input-text"
                                                        name="password"
                                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z]).{8,}"
                                                        placeholder="Password"
                                                        required
                                                        type="password"
                                                    >
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                                                    <input
                                                        v-model="passwordResetData.password_confirmation"
                                                        class="input-text"
                                                        name="confirm_Password"
                                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z]).{8,}"
                                                        placeholder="Conferma Password"
                                                        required type="password"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 mb-3">
                                                    <small class="password-helper">La password deve avere una lunghezza minima di 8 caratteri, contenere una Maiuscola e un carattere speciale ( !,",?,*)</small>
                                                </div>
                                            </div>
                                            <div class="form-group mb-0">
                                                <button class="btn-md button-theme btn-block" type="submit" >Resetta Password</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="isRequestingConfirmEmail" class="reset-password-form">
                                        <form v-on:submit.prevent="doRequestConfirmEmail">
                                        <div class="row">
                                            <div class="col-lg-12 form-group">
                                            <input
                                                v-model="email"
                                                class="input-text"
                                                name="email"
                                                placeholder="Email"
                                                required
                                                type="email"
                                            >
                                            </div>
                                        </div>
                                        <div class="form-group mb-0">
                                            <button
                                                class="btn-md button-theme btn-block"
                                                type="submit"
                                            >Richiedi email di conferma</button>
                                        </div>

                                        </form>
                                    </div>
                                </div>

                                <!-- Footer -->
                                <div class="footer1 pb-2 pt-3">
                                    <span>Sei un'agenzia? <a :href="$root.backofficeUrl" target="_blank"> Accedi qui</a></span>
                                </div>
                            </div>
                            <!-- Form content box end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Helper errori laravel
import * as helper from '../classes/helper.class';
import InvisibleRecaptcha from 'vue-invisible-recaptcha';

export default {
    props: ['sessionid', 'activation_token'],
    components: {
        'invisible-recaptcha': InvisibleRecaptcha
    },
    data() {
        return {
            email: '',
            password: '',
            isResettingPassword: false,
            errors: null,
            register: false,
            recover: false,
            isRequestingConfirmEmail: false,
            passwordResetData: {
                password: null,
                password_confirmation: null,
                activationToken: null,
            },
            registerdUser: {
                nome: null,
                cognome: null,
                telefono: null,
                email: null,
                password: null,
                password_confirmation: null,
                privacy: null,
                recaptcha: null
            },
            captchakey: process.env.MIX_RECAPTCHA
        }
    },
    methods: {
        modalClosed() {
            this.setLogin();
            this.$root.isModalShow = false;
        },
        doResetPasswordRequest() {
            
            // Controllo che le due password siano uguali
            if(this.passwordResetData.password === this.passwordResetData.password_confirmation){
                // Faccio partire il caricamento
                Swal.fire({
                    title: 'Attendere...',
                    type: 'info',
                    onBeforeOpen: () => {
                        Swal.showLoading()
                    },
                });
                // Eseguo la chiamata al back
                window.axios.post(window.base_url + 'people/reset-password/' + this.passwordResetData.activationToken,this.passwordResetData)
                .then(res => {
                    Swal.fire({
                        title: res.data.data.message,
                        type: 'info'
                    });
                    // Setto lo user token nell'header di AXIOS nel componente App
                    this.$root.setUserHeader(res.data.data.access_token)
                    // ritorno i dati dell`utente
                    this.$root.doGetProfiloUtente(res.data.data.access_token)
                    this.isResettingPassword = false
                })
                .catch(error => {
                    if(error.response.status === 422){
                            helper.parseError(error);
                    }
                    else{
                        Swal.fire({
                            text: error.response.data.message,
                            type: 'error',
                            showConfirmButton: false
                        });
                    }
                });
            }
            else{
                Swal.fire({
                    title: 'Le password non coincidono.',
                    type: 'warning'
                });
            }
        },
        doRequestRecoverPassword() {
            Swal.fire({
                title: 'Attendere...',
                type: 'info',
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            // Eseguo la chiamata al back
            window.axios.post(window.base_url + 'people/request-reset-password', {'email': this.email})
            .then(res => {
                Swal.fire({
                    title: res.data.data.message,
                    type: 'info'
                });
            })
            .catch(error => {
                if(error.response.status === 422){
                    helper.parseError(error);
                }
                else{
                    helper.parseGenericException();
                }
            });
        },
        doRequestConfirmEmail() {
            Swal.fire({
                title: 'Attendere...',
                type: 'info',
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            // Eseguo la chiamata al back
            window.axios.post(window.base_url + 'people/request-activation-email', {'email': this.email})
            .then(res => {
                Swal.fire({
                    title: res.data.data.message,
                    type: 'info'
                });
                this.isRequestingConfirmEmail = false
            })
            .catch(error => {
                if(error.response.status === 422){
                    helper.parseError(error);
                }
                else{
                    helper.parseGenericException();
                }
            });
        },
        recoverPassword() {
            this.recover = !this.recover;
            this.register = false;
            this.isResettingPassword = false;
            this.isRequestingConfirmEmail = false;
        },
        setRegister() {
            this.register = true;
            this.recover = false;
            this.isResettingPassword = false;
            this.isRequestingConfirmEmail = false;
        },
        setLogin() {
            this.register = false;
            this.recover = false;
            this.isResettingPassword = false;
            this.isRequestingConfirmEmail = false;
        },
        setRequestConfirmEmail() {
            this.register = false;
            this.recover = false;
            this.isResettingPassword = false;
            this.isRequestingConfirmEmail = true;
        },
        registerUser(e) {
            Swal.fire({
                title: 'Attendere...',
                type: 'info',
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            this.registerdUser.recaptcha = e;
            window.axios.post(window.base_url + 'people/register', this.registerdUser)
            .then(res => {
                Swal.fire({
                    title: 'Registrazione effettuata!',
                    text: 'Per completare la registrazione, controlla la tua casella di posta e clicca sul link nella email che hai ricevuto per verificare il tuo utente.',
                    type: 'info'
                });
                this.setLogin();
            })
            .catch(error => {
                if(error.response.status === 422){
                    helper.parseError(error);
                }
                else{
                    helper.parseGenericException();
                }
            });
        },
        login() {
            this.$root.loginPending = true;
            const params = {
                email: this.email,
                password: this.password
            }
            this.errors = null;
            // Eseguo la chiamata al back
            window.axios.post(window.base_url + 'auth/login', params)
            .then(res => {
                // Setto lo usertoken nell'header di AXIOS nel componente App
                this.$root.setUserHeader(res.data.access_token);
                this.$root.doGetProfiloUtente(res.data.access_token, this.sessionid);
            })
            .catch(error => {
                if(error.response.status === 422){
                    helper.parseError(error);
                }
                else{
                    helper.parseGenericException();
                }

                this.$root.loginPending = false;
            });
        },
    },
    mounted() {
        if (this.activation_token !== undefined && this.activation_token !== "") {
            this.isResettingPassword = true
            this.passwordResetData.activationToken = this.activation_token
            this.$root.showLogin();
        }

        // Mi aggancio alla modale di bootstrap
        $(this.$refs.loginmodal).on("hidden.bs.modal", this.modalClosed)
    }
} 

</script>

<style scoped>
.contact-section {
  position: fixed;
  padding-top: 80px;
  background: rgba(0, 0, 0, 0.60) !important;
  z-index: 999;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(150px);
  opacity: 0;
}
.errors {
  background-color: #a51a1a;
  color: white;
}
.password-helper {
  color: #a51a1a;
  margin-bottom: 10px;
}

.form-content-box {
  margin-top: inherit !important;
  margin-bottom: 20px !important;
}

label {
  color: #111111 !important;
}
</style>
